module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABIElEQVRIx+3UPU4CYRSF4W8IIRZUVhTGiiVQUVBSY29pZekOWIAroGQBLMCaipLWzsJY0JkQYnw+m4uZEMBBx46TTObnnvOeZO5kUjrrJ+EOm1yzsMHdtqSP1xrhr+hv4ddxvsKiBvgCV99svGEQDy4w/QN8iotgDfCWSu/rvrSXB3ycAP7AQyl/v91r2jFO0ArTEKsK8BWGkWlhUp6nPYE5OhHoYnkEvkQ3vB3Mdz3pQPAFvQi2MdvjmaEdnh5e9rH2FgRgjdsANDDGZxxjNGJ2i/UhzsGCKMl4RDNgI4ziuhmzozs6WlAqesJl6Su5xFOVbJFzzlV+KTnn55TSTdzOiqLoVslVLoiS95RSKoqiXTVzUsFv1PhP+LngrHr0BTBLswtoClyLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email.png
// module id = vCvB
// module chunks = 0